import { MaxNumbersOfSuggestions } from 'constants/suggestion';

export const getAvailableSlots = ({
    filtersLength,
    labelsLength,
    packsLength,
}: {
    filtersLength: number;
    labelsLength: number;
    packsLength: number;
}) => {
    let contentSlotsNeeded = 0;
    let contentSlotsDivider = 1;

    if (labelsLength) {
        contentSlotsNeeded++;
    }

    if (packsLength) {
        contentSlotsNeeded++;
        contentSlotsDivider++;
    }

    const availableFilterSlots = Math.min(
        filtersLength,
        MaxNumbersOfSuggestions - contentSlotsNeeded,
    );

    const availableContentSlots =
        MaxNumbersOfSuggestions - availableFilterSlots;

    const availableLabelSlots = Math.min(
        labelsLength,
        Math.floor(availableContentSlots / contentSlotsDivider),
    );

    const availablePackSlots = availableContentSlots - availableLabelSlots;

    return { availableFilterSlots, availableLabelSlots, availablePackSlots };
};
